import { createContext, useContext, useEffect, useState } from 'react'
import { salonAPI } from '../services/api'

const StudioContext = createContext({
  studio: null,
  loading: true,
})

export function StudioProvider({ children }) {
  const [studio, setStudio] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStudio = async () => {
      try {
        const response = await salonAPI.getStudio()
        setStudio(response.data)
      } catch (error) {
        console.error('Error fetching studio profile:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchStudio()
  }, [])

  return (
    <StudioContext.Provider value={{ studio, loading }}>
      {children}
    </StudioContext.Provider>
  )
}

export function useStudio() {
  return useContext(StudioContext)
}
